/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { LlgLocationWithResources } from '../models/LlgLocationWithResources';
import { Pagination } from '../models/Pagination';

export class ListLogSourcesPoliciesResponse {
  'llgLocations': Array<LlgLocationWithResources>;
  'pagination': Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "llgLocations",
      "baseName": "llgLocations",
      "type": "Array<LlgLocationWithResources>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListLogSourcesPoliciesResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

